import { render } from "./BoiteDesCouleurs3.vue?vue&type=template&id=619aa76a&scoped=true"
import script from "./BoiteDesCouleurs3.vue?vue&type=script&lang=js"
export * from "./BoiteDesCouleurs3.vue?vue&type=script&lang=js"

import "./BoiteDesCouleurs3.vue?vue&type=style&index=0&id=619aa76a&scoped=true&lang=css"

import exportComponent from "/Volumes/FITS/Projets-VueJs/montessori-app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-619aa76a"]])

export default __exports__